import React from 'react';
import Icon from '../icon/Icon';
import Button from './Button';
import classNames from 'classnames';
const IconButton = (props) => {
    return (React.createElement(Button, Object.assign({ cls: classNames('button--icon', { hideborder: props.hideborder }) }, props),
        React.createElement(Icon, { name: `${props.icon}`, inverted: props.inverted, ariaHidden: true, family: props.family || '16' })));
};
export default IconButton;
